export const yearAndLocations = {
    '2023': ['Oslo', 'Viken', 'Vestland', 'Bodø'],
    '2022': ['Oslo', 'Trondheim', 'Vestland', 'Viken'],
    '2021': ['Oslo', 'Vestland'], 
    '2020': ['Oslo', 'Trondheim','HNH VGS', 'Askim'], 
    '2019': ['Bergen', 'Oslo', 'Stavanger', 'Trondheim']
}


